import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const lBtn = [
    {
        id: 1,
        title: "Home",
        links: "/"
    },
    {
        id: 2,
        title: "About",
        links: "/about-us"
    },
    {
        id: 3,
        title: "Event",
        links: "/event"
    },
    {
        id: 4,
        title: "Feeds",
        links: "/feeds"
    },
    {
        id: 5,
        title: "Donation",
        links: "/donation"
    },
    {
        id: 6,
        title: "Project",
        links: "/project"
    },
    {
        id: 7,
        title: "Gallery",
        links: "/gallery"
    },
    {
        id: 8,
        title: "Contact us",
        links: "/contact-us"
    },
];

function Header() {
    const pathName = useLocation().pathname
    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] = useState(false);
    function handleDropdown() {
        setMenuOpen(!menuOpen);
    }


    return (
        <>
            <div className='flex md:px-[60px] py-[18px] px-[20px] justify-between items-center bg-[#FFFFFF] fixed top-0 w-full z-[100]'>
                <div
                    className="overlay"
                    onClick={handleDropdown}
                    style={menuOpen ? { right: 0 } : { right: "100%" }}
                ></div>
                <div className='md:flex hidden relative'>
                    <button style={{ background: "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" }} className='py-[14px] h-[44px] w-[89px] rounded-full pl-[15px]'>
                        <img src="/assets/nav/search.svg" alt="" />
                    </button>
                    <input type="text" className='bg-[#F6F6F6] absolute left-[40px] rounded-full py-[10px] px-[17px] border-none font-[400] font-poppins text-[16px] text-[#96818D]' placeholder='search' />
                </div>
                <div className='flex justify-center'>
                    <Link to="/">
                        <img src="/assets/nav/logo.svg" alt="" />
                    </Link>
                </div>
                <div className='md:flex hidden gap-[0px] items-center'>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-instagram text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-facebook text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-youtube text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-twitter text-[#FF6000]"></i>
                    </Link>
                </div>
                <div className='md:hidden flex'>
                    <button onClick={() => setMenuOpen(!menuOpen)}>
                        <i className="bi bi-filter-right text-[30px] text-[#FF6000]"></i>
                    </button>
                </div>
            </div>
            <div style={{ background: "linear-gradient(270deg, #FF6000 0%, #F68B29 100%)" }} className={`flex px-[20px] md:py-[16px] py-0 md:sticky navbar-item fixed md:pl-0 md:w-auto w-[325px] z-[101] h-full sm:bg-transparent sm:flex-row items-center md:items-start sm:pt-0 pt-[30px] flex-col sm:gap-[30px] gap-[20px] lg:top-[80px] top-0 bottom-0 md:right-auto ${menuOpen ? "right-0" : "right-[-325px]"
                }`}>
                <ul className="flex md:items-center flex-wrap w-full md:justify-center justify-start items-start md:gap-[50px] gap-[14px] flex-col md:flex-row">
                    {lBtn.map((item) => (
                        <li
                            key={item.id}
                        >
                            <button onClick={() => navigate(item?.links)} className={`font-[500] font-manrope text-[16px] tracking-[10%] text-[#FFFFFF] border-b uppercase ${pathName === item.links ? 'border-[#FFFFFF]' : 'border-transparent'}`} >
                                {item.title}
                            </button>
                        </li>
                    ))}
                </ul>
                <div className='flex md:hidden relative ml-[-180px]'>
                    <button style={{ background: "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" }} className='py-[14px] h-[44px] w-[89px] rounded-full pl-[15px]'>
                        <img src="/assets/nav/search.svg" alt="" />
                    </button>
                    <input type="text" className='bg-[#F6F6F6] absolute left-[40px] rounded-full py-[10px] px-[17px] border-none font-[400] font-poppins text-[16px] text-[#96818D]' placeholder='search' />
                </div>
                <div className='flex md:hidden gap-[6px] items-center'>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-instagram text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-facebook text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-youtube text-[#FF6000]"></i>
                    </Link>
                    <Link to="/" className='h-[44px] w-[44px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                        <i className="bi bi-twitter text-[#FF6000]"></i>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Header